import { BehaviorSubject } from 'rxjs';
import { ElegantComboBoxElement } from './elegant-combo-box-element';
import { Component, OnInit, Input, Output, EventEmitter, ChangeDetectorRef } from '@angular/core';
import { FormControl, FormGroup, FormBuilder } from '@angular/forms';

@Component({
  selector: 'app-elegant-combo-box-input',
  templateUrl: './elegant-combo-box-input.component.html',
  styleUrls: ['./elegant-combo-box-input.component.scss']
})
export class ElegantComboBoxInputComponent implements OnInit {

  select: FormGroup;

  optionsList: BehaviorSubject<ElegantComboBoxElement[]>;
  _options: ElegantComboBoxElement[];
  @Input() get options() {
    return this._options;
  } set options(newValue: ElegantComboBoxElement[]) {
    if (newValue !== undefined && newValue.length > 0) {
      this.cdRef.detectChanges();
      this._options = newValue;
      this.optionsList.next(this._options);

      if (this.preselectedOptionKey !== undefined) {
        this.silentSelect(this.preselectedOptionKey);
        this.preselectedOptionKey = undefined;
      }
    }
  }

  @Input() title: String;
  @Output() optionSelected = new EventEmitter<ElegantComboBoxElement>();

  @Input() hidden: boolean = false;

  selectedOption: ElegantComboBoxElement;
  preselectedOptionKey: string;

  constructor(
    private formBuilder: FormBuilder,
    private cdRef: ChangeDetectorRef) {
    this.select = this.formBuilder.group({
      privilegeSelect: ''
    });
    this.optionsList = new BehaviorSubject(new Array());
  }

  ngOnInit() {
    this.select = this.formBuilder.group({
      privilegeSelect: ''
    });
  }

  optionPressed(selectedElement: ElegantComboBoxElement) {
    this.optionSelected.emit(selectedElement);
  }

  selectManually(optionKey: string) {
    if (optionKey !== undefined) {
      if (this.optionsList.value !== undefined && this.optionsList.value.length > 0) {
        this.silentSelect(optionKey);
      } else {
        // Aun no s eha cargado la informacion para popular la lista.
        // Nos guardamos el valor y lo seleccionamos cuando podamos.
        this.preselectedOptionKey = optionKey;
      }
    }
  }

  silentSelect(optionKey: string) {
    this.resetSelecteds();
    let selectableElement = this.optionsList.value.find(o => +o.key === +optionKey);
    if (selectableElement === undefined) {
      selectableElement = this.optionsList.value.find(o => o.key === optionKey);
    }
    if (selectableElement !== undefined) {
      // Podemos seleccionarlo.
      this.selectedOption = selectableElement;
      this.select.get('privilegeSelect').setValue(selectableElement);
      this.preselectedOptionKey = optionKey;
    }
  }

  resetSelecteds() {
    this.select.get('privilegeSelect').patchValue([]);
    this.selectedOption = undefined;
  }
}
